import script from "./FootNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./FootNotes.vue?vue&type=script&setup=true&lang=js"

import "./FootNotes.vue?vue&type=style&index=0&id=531a7f6a&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531a7f6a"]])

export default __exports__